webpackJsonp([92721144479812],{

/***/ 242:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  'Eric Windmill': {
	    portfolio: 'https://ericwindmill.com',
	    avatarUrl: 'http://res.cloudinary.com/ericwindmill/image/upload/v1509817350/portfolio_site/no-bg-cartoon.png',
	    email: 'eric@ericwindmill.com',
	    twitter: 'https://twitter.com/ericwindmill?lang=en',
	    github: 'https://github.com/ericwindmill',
	    messenger: 'https://www.messenger.com/t/eric.windmill',
	    instagram: 'https://www.instagram.com/ericwindmill',
	    bio: 'Dart and Flutter dev by day. JS and CSS on the side. Founder of this project.'
	  },
	  'Alex McCulloch': {
	    avatarUrl: 'http://res.cloudinary.com/ericwindmill/image/upload/v1527349506/flutter_by_example/authors/alex_m.jpg',
	    email: 'alexmccx@gmail.com',
	    twitter: 'https://twitter.com/axmccx',
	    github: 'https://github.com/axmccx',
	    messenger: 'https://www.messenger.com/t/axmccx ',
	    bio: 'Student at the University of Toronto Mississauga, computer science.'
	  }
	};

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 75px 1fr;\n  grid-column-gap: 20px;\n  margin-bottom: 50px;\n\n  #profile-img {\n    background-color: #5e6165;\n    width: 75px;\n    height: 75px;\n    background-size: contain;\n    border-radius: 50%;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 75px 1fr;\n  grid-column-gap: 20px;\n  margin-bottom: 50px;\n\n  #profile-img {\n    background-color: #5e6165;\n    width: 75px;\n    height: 75px;\n    background-size: contain;\n    border-radius: 50%;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  h5,\n  h5 > a {\n    background: transparent;\n    font-size: 2rem;\n    margin: 0;\n  }\n\n  p {\n    margin: 3px 0 10px 0;\n  }\n'], ['\n  h5,\n  h5 > a {\n    background: transparent;\n    font-size: 2rem;\n    margin: 0;\n  }\n\n  p {\n    margin: 3px 0 10px 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _UserLinks = __webpack_require__(96);
	
	var _UserLinks2 = _interopRequireDefault(_UserLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserProfile = function (_Component) {
	  _inherits(UserProfile, _Component);
	
	  function UserProfile() {
	    _classCallCheck(this, UserProfile);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UserProfile.prototype.render = function render() {
	    var _props = this.props,
	        twitter = _props.twitter,
	        github = _props.github,
	        messenger = _props.messenger,
	        email = _props.email,
	        instagram = _props.instagram,
	        children = _props.children,
	        avatarUrl = _props.avatarUrl,
	        username = _props.username,
	        mainLink = _props.mainLink;
	
	    return _react2.default.createElement(
	      UserProfileContainer,
	      null,
	      _react2.default.createElement('div', {
	        id: 'profile-img',
	        style: { backgroundImage: 'url(' + avatarUrl + ')' }
	      }),
	      _react2.default.createElement(
	        UserInfo,
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: mainLink },
	            username
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          children
	        ),
	        _react2.default.createElement(_UserLinks2.default, {
	          github: github,
	          twitter: twitter,
	          messenger: messenger,
	          email: email,
	          instagram: instagram
	        })
	      )
	    );
	  };
	
	  return UserProfile;
	}(_react.Component);
	
	exports.default = UserProfile;
	
	
	var UserProfileContainer = _styledComponents2.default.div(_templateObject);
	
	var UserInfo = _styledComponents2.default.div(_templateObject2);
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ', ';\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n\n  max-width: ', ';\n  margin: auto;\n\n  a {\n    color: black;\n    background: ', ';\n    border-bottom: 2px solid ', ';\n    text-decoration: none;\n    transition: 500ms all ease;\n    padding: 0 5px;\n  }\n  a:hover {\n    border-bottom: 2px solid ', ';\n    background: ', ';\n  }\n\n  ul {\n    margin-left: 50px;\n  }\n'], ['\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ', ';\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n\n  max-width: ', ';\n  margin: auto;\n\n  a {\n    color: black;\n    background: ', ';\n    border-bottom: 2px solid ', ';\n    text-decoration: none;\n    transition: 500ms all ease;\n    padding: 0 5px;\n  }\n  a:hover {\n    border-bottom: 2px solid ', ';\n    background: ', ';\n  }\n\n  ul {\n    margin-left: 50px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _UserProfile = __webpack_require__(249);
	
	var _UserProfile2 = _interopRequireDefault(_UserProfile);
	
	var _SiteHeader = __webpack_require__(69);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _contributors = __webpack_require__(242);
	
	var _contributors2 = _interopRequireDefault(_contributors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contributors = function (_React$Component) {
	  _inherits(Contributors, _React$Component);
	
	  function Contributors() {
	    _classCallCheck(this, Contributors);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Contributors.prototype.getContributors = function getContributors() {
	    return Object.keys(_contributors2.default).map(function (name) {
	      return _react2.default.createElement(
	        _UserProfile2.default,
	        {
	          avatarUrl: _contributors2.default[name].avatarUrl,
	          username: name,
	          mainLink: _contributors2.default[name].portfolio,
	          messenger: _contributors2.default[name].messenger,
	          email: _contributors2.default[name].email,
	          instagram: _contributors2.default[name].instagram,
	          twitter: _contributors2.default[name].twitter,
	          github: _contributors2.default[name].github
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          _contributors2.default[name].bio
	        )
	      );
	    });
	  };
	
	  Contributors.prototype.render = function render() {
	    return _react2.default.createElement(
	      ContributorsContainer,
	      null,
	      _react2.default.createElement(_SiteHeader2.default, null),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Contributors'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Flutter By Example is looking for more contributors!'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I\'m hopeful that more Flutter developers will help make this resource rock solid. If you\'d like to help, do so on',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/ericwindmill/flutter_by_example_docs/contributing.md' },
	          'Github'
	        ),
	        'or ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:eric@ericwindmill.com' },
	          'email me'
	        ),
	        '.'
	      ),
	      _react2.default.createElement('div', { style: { height: '50px' } }),
	      this.getContributors()
	    );
	  };
	
	  return Contributors;
	}(_react2.default.Component);
	
	exports.default = Contributors;
	
	
	var ContributorsContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	}, function (props) {
	  return props.theme.linkBackground;
	}, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brand;
	}, function (props) {
	  return props.theme.brandLightest;
	});
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contributors-jsx-cf1a4761b25beef21ec3.js